import {SignDocumentStep, OnSiteSign} from '../types/SignDocumentStep';

export const isSignatureOnSite = (
  signDocumentStep: SignDocumentStep
): signDocumentStep is `OnSite_${OnSiteSign}` => signDocumentStep.startsWith('OnSite_');
